import { onlineManager } from '@tanstack/react-query';
import { CancelToken } from 'axios';
import { productSearchRepositoryOfflineAdapters } from '../../../offline/offlineRequestAdapters/productSearch.repository.offlineAdapters';
import { onlineProductSearchRepository } from './onlineProductSearch.repository';

export const productSearchRepository = (token?: CancelToken) =>
  onlineManager.isOnline()
    ? onlineProductSearchRepository(token)
    : productSearchRepositoryOfflineAdapters;
